export enum DexTradingApiCommands {
  AddESDEXPair = 'AddESDEXPair',
  DeleteESDEXPair = 'DeleteESDEXPair',
}

export enum Engine {
  Solana = 'Solana',
  EVM = 'EVM',
}

export interface DexTradingAddPayload {
  engine: Engine;
  userID: number | null;
  dexTaskID: number | null;
  dexTaskType: number;
  address: string;
  pair: string;
}
